export function uppercaseFirstLetter(str: string) {
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}

export function titleCase(str: string) {
  str = str.replace(/([A-Z])/g, " $1").trim();
  return str;
}
